<div class="option-content-particularity">
    <span class="option-title">A retirar</span>

    <div class="actions">
        <input type="checkbox" (click)="setRetired()" [checked]="isRetired" class="checkbox" />
    </div>
</div>